import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import {
  MatFormFieldModule,
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
  MatStepperModule,
  ErrorStateMatcher,
  ShowOnDirtyErrorStateMatcher,
} from '@angular/material';
import { CdkTableModule } from '@angular/cdk/table';
import { PreinscripcioComponent } from './preinscripcio/preinscripcio.component';
import { LoginComponent } from './login/login.component';
import { HeaderComponent } from './header/header.component';
import { DadesPersonalsComponent } from './dades-personals/dades-personals.component';
import { DadesContacteComponent } from './dades-contacte/dades-contacte.component';
import { EstudisComponent } from './estudis/estudis.component';
import { IdiomesComponent } from './idiomes/idiomes.component';
import { DocumentacioComponent } from './documentacio/documentacio.component';
import { PagamentComponent } from './pagament/pagament.component';
import { ConfirmacioComponent } from './confirmacio/confirmacio.component';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { AltresComponent } from './altres/altres.component';

@NgModule({
  exports: [
    CdkTableModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
  ]
})
export class MaterialModule {}

@NgModule({
  declarations: [
    AppComponent,
    PreinscripcioComponent,
    LoginComponent,
    HeaderComponent,
    DadesPersonalsComponent,
    DadesContacteComponent,
    EstudisComponent,
    IdiomesComponent,
    DocumentacioComponent,
    PagamentComponent,
    ConfirmacioComponent,
    AltresComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    HttpModule,
    FormsModule,
    BrowserAnimationsModule,
    MaterialModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule.forRoot([
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      { path: 'preinscripcio', component: PreinscripcioComponent },
      { path: 'login', component: LoginComponent },
      { path: 'login/:oferta', component: LoginComponent },
      { path: '**', redirectTo: 'login' }
  ])
  ],
  providers: [
    {provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts